var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneReceiverSilhouette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_2595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2325 13.9201C16.0243 12.8867 14.7982 12.2608 13.6048 13.2926L12.8922 13.9162C12.3709 14.3689 11.4015 16.484 7.65358 12.1726C3.90646 7.86665 6.13632 7.19621 6.65846 6.74743L7.37495 6.12304C8.56207 5.08889 8.11407 3.78704 7.25788 2.44694L6.74119 1.63524C5.8811 0.29826 4.94451 -0.579789 3.75427 0.452796L3.11115 1.01475C2.5851 1.39797 1.11466 2.64363 0.757975 5.01006C0.328707 7.84948 1.68285 11.101 4.78529 14.6686C7.88383 18.2378 10.9176 20.0306 13.7913 19.9993C16.1796 19.9736 17.622 18.692 18.0731 18.2261L18.7186 17.6633C19.9057 16.6315 19.1681 15.581 17.9591 14.5453L17.2325 13.9201Z",
    fill: "#5E77F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_2595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneReceiverSilhouette);
export default __webpack_public_path__ + "static/media/phone-receiver-silhouette.1a77cb0c5dce8ca97c99dc0ad7f282c8.svg";
export { ForwardRef as ReactComponent };